import React, { FC } from 'react';
import SimpleBoatListingItem from 'src/calendar/components/SyncCalendarPage/components/SimpleBoatListingItem';
import Icon from 'src/common/components/IconDS22';
import { FullBoatDetail } from 'src/types/boat/BoatDetail';
import s from './SyncedIntegrationsList.module.scss';

type SyncedIntegrationsListProps = {
  list: FullBoatDetail[];
  removeIntegration: (boatId: string) => Promise<void>;
  syncIntegration: (boatId: string) => Promise<void>;
};
const SyncedIntegrationsList: FC<SyncedIntegrationsListProps> = ({
  list,
  removeIntegration,
  syncIntegration,
}) => (
  <div className={s.root}>
    <h1>Synced Calendars</h1>
    <div className={s.list}>
      {list.map(boat => (
        <SimpleBoatListingItem
          key={boat.id}
          photoUrl={boat.photo_url}
          headline={boat.headline}
          variant="wrapContentOnMobile"
        >
          <button
            onClick={() => syncIntegration(boat.id)}
            className={s.action}
            type="button"
          >
            <Icon id="reload" />
            Sync
          </button>
          <button onClick={() => removeIntegration(boat.id)} className={s.action} type="button"><Icon id="trash" />Delete</button>
        </SimpleBoatListingItem>
      ))}
    </div>
  </div>
);

export default SyncedIntegrationsList;
